import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/servebolt.webp';
import screenshot_target from '../../../images/letterfunnel/andrewkillen.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Andrew Killen"
      firstname="Andrew"
      companyname="Servebolt"
      competition="Kinsta en WP Engine"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/andrewkillen.js